<script>
    import { onMount } from "svelte";
    import Quill from "quill";
    import { randString } from "../../scripts/functions";
    import { getEventsAction } from "../../scripts/utils.js";
    import { current_component } from "svelte/internal";

    const events = getEventsAction(current_component);

    export let disabled = false;
    export let editor;
    export let content = "";
    let quill;

    let localClass;
    while (true) {
        let tempClass = "editor-" + randString(5);
        if (document.getElementsByClassName(tempClass).length === 0) {
            localClass = tempClass;
            break;
        }
    }

    onMount(() => {
        quill = new Quill(editor, {
            theme: "snow",
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote", "code-block"],
                    [
                        { list: "ordered" },
                        { list: "bullet" },
                        { indent: "-1" },
                        { indent: "+1" },
                    ],
                    ["link"],
                    ["clean"],
                ],
            },
        });

        quill.on("text-change", () => {
            content = quill.root.innerHTML;
        });
    });

    export function setText(text) {
        quill.root.innerHTML = text;
        content = text;
    }

    export function getText() {
        return content;
    }
</script>

<div
    class="{localClass} {$$props.class ? $$props.class : ''}"
    class:disabled
    use:events
>
    <div bind:this={editor}/>
</div>

<style lang="less" global>
    @import "Editor.less";
</style>
